import { render, staticRenderFns } from "./UserContactInfo.vue?vue&type=template&id=a74a9a1a"
import script from "./UserContactInfo.vue?vue&type=script&lang=js"
export * from "./UserContactInfo.vue?vue&type=script&lang=js"
import style0 from "./UserContactInfo.vue?vue&type=style&index=0&id=a74a9a1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports